const gradients = {} as const;

export default gradients;

export type ThemeGradients = typeof gradients;
export type ThemeGradientsKeys = keyof typeof gradients;
